import store from '../store';
import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';

async function fetch(data){
    return Request("get","api/material-profit/",data)
}

// 导出
async function exports(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/material-profit/export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

// 日期毛利导出
async function materialDateExport(data){
    store.dispatch("fullscreenLoading")
    const response = await Request('get',"api/material-profit/material-date-export",data)
    if(response.data && response.data.status.isOK()){
        snackbar.info(i18n.t("Export.recordedHint"))
    }
    store.dispatch("fullscreenLoadingStop")
    return response
}

export default {
    fetch,
    exports,
    materialDateExport,
}